<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <div
      class="text-center primary--text display font-weight-bold"
      :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
    >
      {{ $t("recover.title") }}
      <p class="text-center primary--text font-weight-light subtitle-2 pt-2">
        {{ $t("recover.subtitle") }}
      </p>
    </div>
    <div class="mt-13 mx-10">
      <v-col class="primary--text py-5" v-for="(field, i) in fields" :key="i">
        <v-row>
          {{ $t("recover." + i) }}
        </v-row>
        <v-row align="center" justify="space-around">
          <v-text-field
            flat
            solo
            hide-details
            single-line
            v-model="fields[i]"
            class="input-custom"
          >
          </v-text-field>
        </v-row>
      </v-col>
      <span v-if="formErrors" class="red--text">{{ formErrors.email }}</span>
    </div>

    <div class="mt-13 mx-10">
      <v-btn
        class="px-13 py-7 mb-5 w-100 primary"
        style="color: var(--text-over-secondary) !important"
        rounded
        outlined
        outlined-border-width="7"
        :loading="sentRequest"
        :disabled="!fields.email"
        @click="recover()"
      >
        {{ $t("recover.title") }}
      </v-btn>
      <v-btn
        style="width: 100%"
        color="primary"
        class="px-13 py-7"
        rounded
        outlined
        outlined-border-width="7"
        @click="$router.push({ name: routeNames.LOGIN })"
      >
        {{ $t("recover.go_back") }}
      </v-btn>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import RedirectHandler from "@/mixins/RedirectHandler";
import errorManager from "../services/error.manager";

export default {
  name: "SetPasswordView",
  props: ["routeNames", "auth"],
  mixins: [RedirectHandler],
  data() {
    return {
      fields: {
        email: null,
      },
      sentRequest: false,
      formErrors: null,
    };
  },
  methods: {
    recover() {
      const context = this;
      this.sentRequest = true;
      this.auth
        .recover(context, this.fields.email)
        .then(() => {
          const action = "recover";
          const viewData = {
            primary_text: {
              vicon: "check_circle",
              text: "recover.email_send",
            },
            secondary_text: "recover.email_send_subtitle",
            redirectTo: "LOGIN",
          };

          this.successSignUpRedirect(action, viewData, true);
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        })
        .finally(() => {
          context.sentRequest = false;
        });
    },
  },
  components: {
    Layout,
  },
};
</script>

<style>
.theme--light.v-btn.v-btn--disabled {
  opacity: 0.5 !important;
}
</style>
